// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import '../Styles/O2CAgent.css';
// import {
//   ingestPurchaseOrder,
//   confirmIngestedPurchaseOrder,
//   getOrders,
//   getOrderDetail,
//   processOrder,
//   approveOrder,
// } from '../utils/o2cApi';

// const EMPTY_DRAFT = {
//   customer_id: '',
//   po_number: '',
//   currency: 'USD',
//   lines: [],
// };

// const PAGE_META = {
//   upload: {
//     title: 'Upload Purchase Order',
//     subtitle: 'Drop a customer PO document and scan for extraction.',
//   },
//   tracker: {
//     title: 'Review Purchase Order',
//     subtitle: 'Validate extracted values against source and confirm.',
//   },
//   dashboard: {
//     title: 'Process Dashboard',
//     subtitle: 'Track all submitted purchase orders and approvals.',
//   },
// };

// function asNum(value) {
//   const n = Number(value);
//   return Number.isFinite(n) ? n : 0;
// }

// function formatMoney(value, currency = 'USD') {
//   const amount = Number(value) || 0;
//   try {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: currency || 'USD',
//       maximumFractionDigits: 2,
//     }).format(amount);
//   } catch (_err) {
//     return `${currency || 'USD'} ${amount.toFixed(2)}`;
//   }
// }

// function formatDate(value) {
//   if (!value) return '-';
//   const dt = new Date(value);
//   if (Number.isNaN(dt.getTime())) return value;
//   return dt.toLocaleString('en-GB', {
//     day: '2-digit',
//     month: 'short',
//     year: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit',
//   });
// }

// function getStatusTone(status) {
//   const s = String(status || '').toLowerCase();
//   if (/invoice/.test(s) || s === 'invoiced') return 'success';
//   if (/reject/.test(s)) return 'danger';
//   if (/pause|pending/.test(s)) return 'warn';
//   if (/process|created/.test(s)) return 'info';
//   return 'muted';
// }

// function statusLabel(status) {
//   const s = String(status || '').toLowerCase();
//   if (!s) return 'unknown';
//   return s.replace(/_/g, ' ');
// }

// /* ─── SVG Icons ────────────────────────────────────────────── */
// const IconUpload = () => (
//   <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="16 16 12 12 8 16" />
//     <line x1="12" y1="12" x2="12" y2="21" />
//     <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
//   </svg>
// );

// const IconCheck = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="20 6 9 17 4 12" />
//   </svg>
// );

// const IconRefresh = ({ spinning }) => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ animation: spinning ? 'o2cSpin 0.8s linear infinite' : 'none' }}>
//     <polyline points="23 4 23 10 17 10" />
//     <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
//   </svg>
// );

// const IconArrowLeft = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
//     <line x1="19" y1="12" x2="5" y2="12" />
//     <polyline points="12 19 5 12 12 5" />
//   </svg>
// );

// const IconSearch = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <circle cx="11" cy="11" r="8" />
//     <line x1="21" y1="21" x2="16.65" y2="16.65" />
//   </svg>
// );

// const IconFile = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//     <polyline points="14 2 14 8 20 8" />
//   </svg>
// );

// const IconPlus = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
//     <line x1="12" y1="5" x2="12" y2="19" />
//     <line x1="5" y1="12" x2="19" y2="12" />
//   </svg>
// );

// const IconTrash = () => (
//   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="3 6 5 6 21 6" />
//     <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
//     <path d="M10 11v6M14 11v6" />
//     <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
//   </svg>
// );

// const IconFilter = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
//   </svg>
// );

// const IconAlert = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
//     <line x1="12" y1="9" x2="12" y2="13" />
//     <line x1="12" y1="17" x2="12.01" y2="17" />
//   </svg>
// );

// const IconBox = () => (
//   <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
//     <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
//     <line x1="12" y1="22.08" x2="12" y2="12" />
//   </svg>
// );

// /* ─── Step Indicator ───────────────────────────────────────── */
// const STEPS = ['Upload PO', 'Review & Edit', 'Dashboard'];
// const StepIndicator = ({ current }) => {
//   const idx = current === 'upload' ? 0 : current === 'tracker' ? 1 : 2;
//   return (
//     <div className="o2c-steps">
//       {STEPS.map((label, i) => (
//         <React.Fragment key={label}>
//           <div className={`o2c-step ${i < idx ? 'past' : i === idx ? 'current' : ''}`}>
//             <div className="o2c-step-circle">
//               {i < idx ? <IconCheck /> : <span>{i + 1}</span>}
//             </div>
//             <span className="o2c-step-label">{label}</span>
//           </div>
//           {i < STEPS.length - 1 && (
//             <div className={`o2c-step-line ${i < idx ? 'done' : ''}`} />
//           )}
//         </React.Fragment>
//       ))}
//     </div>
//   );
// };

// /* ─── Skeleton row ─────────────────────────────────────────── */
// const SkeletonRow = ({ cols = 10 }) => (
//   <tr className="o2c-skeleton-row">
//     {Array.from({ length: cols }).map((_, i) => (
//       <td key={i}><div className="o2c-skeleton" /></td>
//     ))}
//   </tr>
// );

// /* ─── Main component ───────────────────────────────────────── */
// const O2CAgent = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [activePage, setActivePage] = useState('upload');
//   const [file, setFile] = useState(null);
//   const [dragActive, setDragActive] = useState(false);
//   const fileInputRef = useRef(null);

//   const [ingestLoading, setIngestLoading] = useState(false);
//   const [confirmLoading, setConfirmLoading] = useState(false);
//   const [ordersLoading, setOrdersLoading] = useState(false);
//   const [detailLoading, setDetailLoading] = useState(false);

//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   const [ingestResult, setIngestResult] = useState(null);
//   const [draft, setDraft] = useState(EMPTY_DRAFT);
//   const [confirmResult, setConfirmResult] = useState(null);

//   const [orders, setOrders] = useState([]);
//   const [selectedOrderId, setSelectedOrderId] = useState('');
//   const [detail, setDetail] = useState(null);
//   const [toastMessage, setToastMessage] = useState('');

//   /* search + filter */
//   const [searchQuery, setSearchQuery] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');

//   const selectedOrder = useMemo(
//     () => orders.find((o) => o.order_id === selectedOrderId) || null,
//     [orders, selectedOrderId]
//   );

//   const draftTotal = useMemo(
//     () => (draft.lines || []).reduce((sum, line) => sum + (asNum(line.quantity) * asNum(line.unit_price)), 0),
//     [draft.lines]
//   );

//   const pageMeta = PAGE_META[activePage] || PAGE_META.upload;

//   const dashboardStats = useMemo(() => {
//     const byStatus = (orders || []).reduce((acc, order) => {
//       const key = String(order?.status || 'unknown').toLowerCase();
//       acc[key] = (acc[key] || 0) + 1;
//       return acc;
//     }, {});
//     const totalValue = (orders || []).reduce((sum, order) => sum + (Number(order?.total_value) || 0), 0);
//     return {
//       totalOrders: orders.length,
//       processing: (byStatus.processing || 0) + (byStatus.created || 0),
//       invoiced: byStatus.invoiced || 0,
//       pendingApproval: byStatus.pending_approval || byStatus.paused || 0,
//       rejected: byStatus.rejected || 0,
//       totalValue,
//       byStatus,
//     };
//   }, [orders]);

//   const approvalQueue = useMemo(
//     () => orders.filter((o) => {
//       const s = String(o?.status || '').toLowerCase();
//       return s === 'pending_approval' || s === 'paused';
//     }),
//     [orders]
//   );

//   const activeApprovalOrder = useMemo(() => {
//     if (selectedOrderId) {
//       const selected = approvalQueue.find((o) => o.order_id === selectedOrderId);
//       if (selected) return selected;
//     }
//     return approvalQueue[0] || null;
//   }, [approvalQueue, selectedOrderId]);

//   const filteredOrders = useMemo(() => {
//     const q = searchQuery.toLowerCase();
//     return orders.filter((o) => {
//       const matchSearch = !q ||
//         (o.order_id || '').toLowerCase().includes(q) ||
//         (o.customer_id || '').toLowerCase().includes(q) ||
//         (o.po_number || '').toLowerCase().includes(q) ||
//         (o.sap_so_number || '').toLowerCase().includes(q);
//       const matchStatus = statusFilter === 'all' ||
//         String(o.status || '').toLowerCase().includes(statusFilter);
//       return matchSearch && matchStatus;
//     });
//   }, [orders, searchQuery, statusFilter]);

//   const updateHeader = (field, value) => {
//     setDraft((prev) => ({ ...prev, [field]: value }));
//   };

//   const updateLine = (index, field, value) => {
//     setDraft((prev) => ({
//       ...prev,
//       lines: prev.lines.map((line, idx) => {
//         if (idx !== index) return line;
//         if (['line_no', 'quantity', 'unit_price'].includes(field)) {
//           return { ...line, [field]: asNum(value) };
//         }
//         return { ...line, [field]: value };
//       }),
//     }));
//   };

//   const addLine = () => {
//     setDraft((prev) => ({
//       ...prev,
//       lines: [
//         ...prev.lines,
//         { line_no: prev.lines.length + 1, material_id: '', quantity: 1, unit_price: 0, uom: 'EA' },
//       ],
//     }));
//   };

//   const removeLine = (index) => {
//     setDraft((prev) => ({
//       ...prev,
//       lines: prev.lines
//         .filter((_, idx) => idx !== index)
//         .map((line, idx) => ({ ...line, line_no: idx + 1 })),
//     }));
//   };

//   const clearMessages = () => { setError(''); setSuccess(''); };

//   const loadOrderDetail = async (orderId) => {
//     if (!orderId) return;
//     setDetailLoading(true);
//     setError('');
//     try {
//       const data = await getOrderDetail(orderId);
//       setDetail(data);
//     } catch (err) {
//       setError(err.message || 'Failed to load order detail');
//     } finally {
//       setDetailLoading(false);
//     }
//   };

//   const refreshOrders = async (preferredId) => {
//     setOrdersLoading(true);
//     setError('');
//     try {
//       const data = await getOrders();
//       const list = Array.isArray(data?.orders) ? data.orders : [];
//       setOrders(list);
//       const nextId = preferredId || selectedOrderId || list[0]?.order_id || '';
//       setSelectedOrderId(nextId);
//       if (nextId) {
//         await loadOrderDetail(nextId);
//       } else {
//         setDetail(null);
//       }
//     } catch (err) {
//       setError(err.message || 'Failed to load orders');
//     } finally {
//       setOrdersLoading(false);
//     }
//   };

//   const handleIngest = async () => {
//     if (!file) { setError('Select a file first.'); return; }
//     setIngestLoading(true);
//     clearMessages();
//     setConfirmResult(null);
//     try {
//       const data = await ingestPurchaseOrder(file);
//       setIngestResult(data);
//       setDraft(data?.draft_order || data?.extracted || EMPTY_DRAFT);
//       setSuccess(data?.message || 'PO extracted successfully. Review and confirm.');
//       setToastMessage('PO extracted. Review fields and confirm when ready.');
//       navigate('/o2c-agent/tracker');
//     } catch (err) {
//       setError(err.message || 'Failed to ingest PO');
//     } finally {
//       setIngestLoading(false);
//     }
//   };

//   const handleConfirm = async () => {
//     if (!draft.customer_id || !draft.po_number || !draft.currency || draft.lines.length === 0) {
//       setError('Customer ID, PO number, currency, and at least one line are required.');
//       return;
//     }
//     const normalizedLines = (draft.lines || [])
//       .map((line, idx) => ({
//         line_no: asNum(line.line_no) || idx + 1,
//         material_id: String(line.material_id || '').trim(),
//         quantity: asNum(line.quantity),
//         unit_price: asNum(line.unit_price),
//         uom: String(line.uom || '').trim() || 'EA',
//       }))
//       .filter((line) => line.material_id);
//     if (normalizedLines.length === 0) {
//       setError('At least one line with a material ID is required.');
//       return;
//     }
//     const invalidLine = normalizedLines.find((l) => l.quantity <= 0 || l.unit_price < 0);
//     if (invalidLine) {
//       setError(`Invalid values in line ${invalidLine.line_no}.`);
//       return;
//     }
//     const payload = {
//       customer_id: String(draft.customer_id).trim(),
//       po_number: String(draft.po_number).trim(),
//       currency: String(draft.currency).trim().toUpperCase(),
//       lines: normalizedLines,
//     };
//     setConfirmLoading(true);
//     clearMessages();
//     try {
//       const data = await confirmIngestedPurchaseOrder(payload);
//       setConfirmResult(data);
//       setSuccess(data?.message ?? 'PO processed successfully');
//       await refreshOrders(data?.order_id);
//       setToastMessage(`${data?.order_id || 'Order'} submitted to O2C pipeline.`);
//       navigate('/o2c-agent/dashboard');
//     } catch (err) {
//       setError(err.message || 'Failed to confirm PO');
//     } finally {
//       setConfirmLoading(false);
//     }
//   };

//   const handleReprocess = async () => {
//     if (!selectedOrderId) return;
//     setDetailLoading(true);
//     clearMessages();
//     try {
//       const data = await processOrder(selectedOrderId);
//       setSuccess(data?.message ?? 'Order processed successfully');
//       await loadOrderDetail(selectedOrderId);
//       await refreshOrders(selectedOrderId);
//       setToastMessage(`${selectedOrderId} re-processed successfully.`);
//     } catch (err) {
//       setError(err.message || 'Failed to process order');
//     } finally {
//       setDetailLoading(false);
//     }
//   };

//   const handleDecision = async (decision) => {
//     if (!selectedOrderId) return;
//     setDetailLoading(true);
//     clearMessages();
//     try {
//       const data = await approveOrder(selectedOrderId, decision);
//       setSuccess(cleanMsg(data?.message) || `Order ${decision}d successfully`);
//       await loadOrderDetail(selectedOrderId);
//       await refreshOrders(selectedOrderId);
//       setToastMessage(`${selectedOrderId} ${decision === 'approve' ? 'approved ✓' : 'rejected'}.`);
//     } catch (err) {
//       setError(err.message || `Failed to ${decision} order`);
//     } finally {
//       setDetailLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (location.pathname.endsWith('/dashboard')) { setActivePage('dashboard'); return; }
//     if (location.pathname.endsWith('/tracker'))   { setActivePage('tracker');   return; }
//     setActivePage('upload');
//   }, [location.pathname]);

//   useEffect(() => {
//     if ((activePage === 'dashboard' || activePage === 'tracker') && orders.length === 0) {
//       refreshOrders();
//     }
//   }, [activePage]);

//   useEffect(() => {
//     if (!toastMessage) return undefined;
//     const timer = setTimeout(() => setToastMessage(''), 3400);
//     return () => clearTimeout(timer);
//   }, [toastMessage]);

//   useEffect(() => {
//     if (activeApprovalOrder?.order_id) setSelectedOrderId(activeApprovalOrder.order_id);
//   }, [activeApprovalOrder?.order_id]);

//   const navigateToPage = (page) => {
//     navigate(page === 'dashboard' ? '/o2c-agent/dashboard' : page === 'tracker' ? '/o2c-agent/tracker' : '/o2c-agent/upload');
//   };

//   const triggerFilePicker = () => fileInputRef.current?.click();

//   const onFileSelected = (selected) => {
//     if (!selected) return;
//     setFile(selected);
//     clearMessages();
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     event.stopPropagation();
//     setDragActive(false);
//     const dropped = event.dataTransfer?.files?.[0];
//     if (dropped) onFileSelected(dropped);
//   };

//   /* file extension helper */
//   const fileExt = file ? file.name.split('.').pop().toUpperCase() : null;

//   return (
//     <div className="o2c-page">

//       {/* ── Topbar ── */}
//       <header className="o2c-topbar">
//         <div className="o2c-title">
//           <h1>{pageMeta.title}</h1>
//           <p>{pageMeta.subtitle}</p>
//         </div>
//         <div className="o2c-topbar-actions">
//           <button type="button" className="o2c-btn" onClick={() => refreshOrders()} disabled={ordersLoading}>
//             <IconRefresh spinning={ordersLoading} />
//             {ordersLoading ? 'Refreshing…' : 'Refresh'}
//           </button>
//           <button type="button" className="o2c-btn" onClick={() => navigate('/home')}>
//             <IconArrowLeft /> Back to Home
//           </button>
//         </div>
//       </header>

//       {/* ── Step indicator ── */}
//       <StepIndicator current={activePage} />

//       {/* ── Tab nav ── */}
//       <nav className="o2c-page-nav" aria-label="O2C pages">
//         {['upload', 'tracker', 'dashboard'].map((page) => (
//           <button
//             key={page}
//             type="button"
//             className={`o2c-page-btn ${activePage === page ? 'active' : ''}`}
//             onClick={() => navigateToPage(page)}
//           >
//             {page === 'upload' && '📄 '}
//             {page === 'tracker' && '✏️ '}
//             {page === 'dashboard' && '📊 '}
//             {page === 'upload' ? 'Upload Purchase Order' : page === 'tracker' ? 'Review Purchase Order' : 'Process Dashboard'}
//             {page === 'dashboard' && orders.length > 0 && (
//               <span className="o2c-tab-badge">{orders.length}</span>
//             )}
//           </button>
//         ))}
//       </nav>

//       {/* ── Messages ── */}
//       {error   && <div className="o2c-error"   role="alert"><IconAlert />{error}</div>}
//       {success && <div className="o2c-success"  role="status"><IconCheck />{success}</div>}

//       {/* ════════════════════════════════ UPLOAD PAGE ════════════════════════════════ */}
//       {activePage === 'upload' && (
//         <div className="o2c-card o2c-animate-in">
//           <div className="o2c-card-head">
//             <h2>Upload Purchase Order</h2>
//             <p>Drop a customer PO document, review extracted fields side by side with source, then confirm before the O2C pipeline starts.</p>
//           </div>

//           <div className="o2c-upload-layout">
//             {/* Drop zone panel */}
//             <div className="o2c-upload-card">
//               <h3>Drop Zone</h3>
//               <div
//                 className={`o2c-drop-zone ${dragActive ? 'active' : ''} ${file ? 'has-file' : ''}`}
//                 onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); setDragActive(true); }}
//                 onDragOver={(e)  => { e.preventDefault(); e.stopPropagation(); setDragActive(true); }}
//                 onDragLeave={(e) => { e.preventDefault(); e.stopPropagation(); setDragActive(false); }}
//                 onDrop={handleDrop}
//                 onClick={triggerFilePicker}
//                 role="button"
//                 tabIndex={0}
//               >
//                 <div className={`o2c-drop-icon ${dragActive ? 'bounce' : ''}`}>
//                   <IconUpload />
//                 </div>
//                 <h4>{dragActive ? 'Release to upload' : 'Drag & drop your PO here'}</h4>
//                 <p>or click anywhere to browse</p>
//                 <button type="button" className="o2c-btn primary" onClick={(e) => { e.stopPropagation(); triggerFilePicker(); }}>
//                   Browse Files
//                 </button>
//                 <div className="o2c-file-tags">
//                   {['PDF', 'PNG', 'JPG', 'XLSX', 'CSV'].map((t) => (
//                     <span key={t}>{t}</span>
//                   ))}
//                 </div>
//                 <input
//                   ref={fileInputRef}
//                   type="file"
//                   accept="application/pdf,image/*,.xlsx,.xls,.csv"
//                   onChange={(e) => onFileSelected(e.target.files?.[0] || null)}
//                   className="o2c-hidden-input"
//                 />
//               </div>

//               {file && (
//                 <div className="o2c-picked-file o2c-animate-in">
//                   <div className="o2c-picked-file-info">
//                     <div className="o2c-file-ext-badge">{fileExt}</div>
//                     <span>{file.name}</span>
//                   </div>
//                   <small>{Math.max(1, Math.round(file.size / 1024))} KB</small>
//                 </div>
//               )}

//               <button
//                 type="button"
//                 className="o2c-btn dark-block"
//                 onClick={handleIngest}
//                 disabled={!file || ingestLoading}
//               >
//                 {ingestLoading ? (
//                   <><span className="o2c-spinner" />Uploading and scanning…</>
//                 ) : (
//                   <><IconUpload /> Scan PO For Review</>
//                 )}
//               </button>

//               {(ingestLoading || ingestResult) && (
//                 <ol className="o2c-scan-steps">
//                   <li className="done">Uploading and scanning document</li>
//                   <li className={ingestResult ? 'done' : 'active'}>Preparing side-by-side review</li>
//                   <li className={ingestResult ? 'done' : ''}>Waiting for user confirmation</li>
//                 </ol>
//               )}
//             </div>

//             {/* How it works panel */}
//             <div className="o2c-how-card">
//               <h3>How It Works</h3>
//               <ol>
//                 <li>
//                   <strong>Upload PO Document</strong>
//                   <p>Drop a PDF, image, or spreadsheet of any customer purchase order.</p>
//                 </li>
//                 <li>
//                   <strong>AI Extraction</strong>
//                   <p>The model extracts customer, PO number, line items, quantities, and prices.</p>
//                 </li>
//                 <li>
//                   <strong>Review and Correct</strong>
//                   <p>Validate extracted values, fix any OCR errors, and confirm final inputs.</p>
//                 </li>
//                 <li>
//                   <strong>SAP Sales Order to Invoice</strong>
//                   <p>After confirmation, O2C processes end-to-end and handles approvals if needed.</p>
//                 </li>
//               </ol>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ════════════════════════════════ TRACKER PAGE ═══════════════════════════════ */}
//       {activePage === 'tracker' && (
//         <div className="o2c-card o2c-animate-in">
//           <div className="o2c-card-head">
//             <h2>Review Purchase Order</h2>
//             <p>Validate extracted values against the original PO, correct mistakes, and confirm when data looks right.</p>
//           </div>

//           <div className="o2c-review-file-row">
//             <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//               <IconFile />
//               <span>{file?.name || ingestResult?.filename || 'No file uploaded yet'}</span>
//             </div>
//             <span className="o2c-line-count-badge">{draft.lines.length} line{draft.lines.length !== 1 ? 's' : ''}</span>
//           </div>

//           <div className="o2c-review-layout">
//             {/* Left: original */}
//             <section className="o2c-review-left">
//               <header>
//                 <h3>Original Purchase Order</h3>
//                 <small>{file?.name || ingestResult?.filename || '-'}</small>
//               </header>
//               <div className="o2c-preview-placeholder">
//                 <div className="o2c-preview-icon"><IconBox /></div>
//                 <strong>{file?.name || ingestResult?.filename || 'No document selected'}</strong>
//                 <p>Live preview is available for PDF and image files.<br />You can still review and edit extracted fields before processing.</p>
//               </div>
//             </section>

//             {/* Right: editable fields */}
//             <section className="o2c-review-right">
//               <header>
//                 <h3>Editable Extracted Fields</h3>
//                 <small>Used for sales order creation</small>
//               </header>

//               <p className="o2c-help-banner">
//                 Compare uploaded PO with extracted values and update as needed.
//               </p>

//               <div className="o2c-grid o2c-grid-header">
//                 <label className="o2c-label">
//                   Customer ID
//                   <input type="text" value={draft.customer_id || ''} onChange={(e) => updateHeader('customer_id', e.target.value)} placeholder="e.g. CUST-001" />
//                 </label>
//                 <label className="o2c-label">
//                   PO Number
//                   <input type="text" value={draft.po_number || ''} onChange={(e) => updateHeader('po_number', e.target.value)} placeholder="e.g. PO-2024-001" />
//                 </label>
//                 <label className="o2c-label" style={{ gridColumn: '1 / -1' }}>
//                   Currency
//                   <input type="text" maxLength={3} value={draft.currency || ''} onChange={(e) => updateHeader('currency', e.target.value.toUpperCase())} placeholder="USD" style={{ maxWidth: 120 }} />
//                 </label>
//               </div>

//               <div className="o2c-review-lines-title">
//                 <h4>Line Items ({draft.lines.length})</h4>
//                 <button type="button" className="o2c-btn" onClick={addLine}>
//                   <IconPlus /> Add Line
//                 </button>
//               </div>

//               {(draft.lines || []).map((line, index) => (
//                 <div key={`${line.line_no}-${index}`} className="o2c-line-card o2c-line-enter">
//                   <div className="o2c-line-card-head">
//                     <span>Line {index + 1}</span>
//                     <button type="button" className="o2c-btn danger icon-btn" onClick={() => removeLine(index)}>
//                       <IconTrash />
//                     </button>
//                   </div>
//                   <div className="o2c-line-grid">
//                     <label className="o2c-label">
//                       Line No
//                       <input type="number" min="1" value={line.line_no} onChange={(e) => updateLine(index, 'line_no', e.target.value)} />
//                     </label>
//                     <label className="o2c-label">
//                       Material ID
//                       <input type="text" value={line.material_id || ''} onChange={(e) => updateLine(index, 'material_id', e.target.value)} placeholder="MAT-001" />
//                     </label>
//                     <label className="o2c-label">
//                       Quantity
//                       <input type="number" min="1" value={line.quantity} onChange={(e) => updateLine(index, 'quantity', e.target.value)} />
//                     </label>
//                     <label className="o2c-label">
//                       Unit Price
//                       <input type="number" min="0" step="0.01" value={line.unit_price} onChange={(e) => updateLine(index, 'unit_price', e.target.value)} />
//                     </label>
//                     <label className="o2c-label">
//                       UOM
//                       <input type="text" value={line.uom || ''} onChange={(e) => updateLine(index, 'uom', e.target.value)} placeholder="EA" />
//                     </label>
//                   </div>
//                 </div>
//               ))}

//               {draft.lines.length === 0 && (
//                 <p className="o2c-hint">No lines extracted yet. Click "Add Line" to add manually.</p>
//               )}

//               <div className="o2c-review-footer">
//                 <div className="o2c-total-display">
//                   <span>Total</span>
//                   <strong>{formatMoney(draftTotal, draft.currency)}</strong>
//                 </div>
//                 <div className="o2c-action-row">
//                   <button type="button" className="o2c-btn" onClick={() => navigate('/o2c-agent/upload')}>
//                     <IconArrowLeft /> Back
//                   </button>
//                   <button type="button" className="o2c-btn dark-block" onClick={handleConfirm} disabled={confirmLoading}>
//                     {confirmLoading ? (
//                       <><span className="o2c-spinner" />Confirming…</>
//                     ) : (
//                       <>Confirm & Start O2C</>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </section>
//           </div>
//         </div>
//       )}

//       {/* ════════════════════════════════ DASHBOARD PAGE ═════════════════════════════ */}
//       {activePage === 'dashboard' && (
//         <div className="o2c-card o2c-animate-in">
//           <div className="o2c-card-head">
//             <h2>Process Dashboard</h2>
//             <p>Real-time O2C pipeline status for all submitted purchase orders.</p>
//           </div>

//           {/* Stats */}
//           <div className="o2c-stats">
//             <div className="o2c-stat o2c-stat-enter" style={{ '--delay': '0ms' }}>
//               <div>
//                 <p>Total Orders</p>
//                 <strong>{dashboardStats.totalOrders}</strong>
//                 <small>all time</small>
//               </div>
//             </div>
//             <div className="o2c-stat o2c-stat-enter" style={{ '--delay': '60ms' }}>
//               <div>
//                 <p>Processing</p>
//                 <strong>{dashboardStats.processing}</strong>
//                 <small>in pipeline</small>
//               </div>
//             </div>
//             <div className="o2c-stat o2c-stat-enter" style={{ '--delay': '120ms' }}>
//               <div>
//                 <p>Awaiting Approval</p>
//                 <strong>{dashboardStats.pendingApproval}</strong>
//                 <small>need action</small>
//               </div>
//             </div>
//             <div className="o2c-stat o2c-stat-enter" style={{ '--delay': '180ms' }}>
//               <div>
//                 <p>Completed</p>
//                 <strong>{dashboardStats.invoiced}</strong>
//                 <small>invoiced</small>
//               </div>
//             </div>
//             <div className="o2c-stat o2c-stat-enter" style={{ '--delay': '240ms' }}>
//               <div>
//                 <p>Errors / Holds</p>
//                 <strong>{dashboardStats.rejected}</strong>
//                 <small>need review</small>
//               </div>
//             </div>
//           </div>

//           {/* Approval queue */}
//           {activeApprovalOrder && (
//             <section className="o2c-approval-queue o2c-animate-in">
//               <div className="o2c-approval-head">
//                 <h3><IconAlert /> Human Approval Required</h3>
//                 <span>{approvalQueue.length} waiting</span>
//               </div>
//               <div className="o2c-approval-item">
//                 <div>
//                   <div className="o2c-approval-meta">
//                     <strong>{activeApprovalOrder.order_id}</strong>
//                     <span className={`o2c-status o2c-status-${getStatusTone(activeApprovalOrder.status)}`}>
//                       {statusLabel(activeApprovalOrder.status)}
//                     </span>
//                   </div>
//                   <p>
//                     Customer <b>{activeApprovalOrder.customer_id || '-'}</b>
//                     {' · '}PO <b>{activeApprovalOrder.po_number || '-'}</b>
//                     {' · '}{(activeApprovalOrder.currency || 'USD')} {Number(activeApprovalOrder.total_value || 0).toLocaleString()}
//                     {activeApprovalOrder.sap_so_number ? ` · SAP SO ${activeApprovalOrder.sap_so_number}` : ''}
//                   </p>
//                   <div className="o2c-approval-message">
//                     {activeApprovalOrder.approval_message || 'Order paused by the agent and waiting for decision.'}
//                   </div>
//                 </div>
//                 <div className="o2c-approval-actions">
//                   <button
//                     type="button"
//                     className="o2c-btn success"
//                     onClick={async () => { setSelectedOrderId(activeApprovalOrder.order_id); await handleDecision('approve'); }}
//                     disabled={detailLoading}
//                   >
//                     {detailLoading ? <span className="o2c-spinner" /> : null} Approve
//                   </button>
//                   <button
//                     type="button"
//                     className="o2c-btn danger"
//                     onClick={async () => { setSelectedOrderId(activeApprovalOrder.order_id); await handleDecision('reject'); }}
//                     disabled={detailLoading}
//                   >
//                     Reject
//                   </button>
//                 </div>
//               </div>
//             </section>
//           )}

//           {/* Orders table */}
//           <section className="o2c-orders-block">
//             <div className="o2c-orders-head">
//               <h3>Orders</h3>
//               <div className="o2c-table-controls">
//                 <div className="o2c-search-wrap">
//                   <IconSearch />
//                   <input
//                     type="text"
//                     className="o2c-search-input"
//                     placeholder="Search orders…"
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                   />
//                 </div>
//                 <div className="o2c-filter-wrap">
//                   <IconFilter />
//                   <select
//                     className="o2c-filter-select"
//                     value={statusFilter}
//                     onChange={(e) => setStatusFilter(e.target.value)}
//                   >
//                     <option value="all">All Status</option>
//                     <option value="created">Created</option>
//                     <option value="processing">Processing</option>
//                     <option value="pending">Pending Approval</option>
//                     <option value="invoiced">Invoiced</option>
//                     <option value="rejected">Rejected</option>
//                   </select>
//                 </div>
//                 <span className="o2c-orders-count">{filteredOrders.length} order{filteredOrders.length !== 1 ? 's' : ''}</span>
//               </div>
//             </div>

//             <div className="o2c-table-wrap">
//               <table className="o2c-table">
//                 <thead>
//                   <tr>
//                     <th>Order ID</th>
//                     <th>Customer</th>
//                     <th>PO Number</th>
//                     <th>Status</th>
//                     <th>SAP SO</th>
//                     <th>Delivery</th>
//                     <th>Invoice</th>
//                     <th>Total Value</th>
//                     <th>Created At</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {ordersLoading && (
//                     <>
//                       <SkeletonRow cols={10} />
//                       <SkeletonRow cols={10} />
//                       <SkeletonRow cols={10} />
//                       <SkeletonRow cols={10} />
//                     </>
//                   )}
//                   {!ordersLoading && filteredOrders.length === 0 && (
//                     <tr>
//                       <td colSpan={10}>
//                         <div className="o2c-empty-state">
//                           <div className="o2c-empty-icon"><IconBox /></div>
//                           <strong>{orders.length === 0 ? 'No orders yet' : 'No results found'}</strong>
//                           <p>{orders.length === 0 ? 'Upload and confirm a PO to populate the dashboard.' : 'Try adjusting your search or filter.'}</p>
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                   {!ordersLoading && filteredOrders.map((order, idx) => (
//                     <tr key={order.order_id} className="o2c-table-row-enter" style={{ '--row-delay': `${idx * 30}ms` }}>
//                       <td className="o2c-order-link">{order.order_id}</td>
//                       <td>{order.customer_id || '-'}</td>
//                       <td>{order.po_number || '-'}</td>
//                       <td>
//                         <span className={`o2c-status o2c-status-${getStatusTone(order.status)}`}>
//                           {statusLabel(order.status)}
//                         </span>
//                       </td>
//                       <td>{order.sap_so_number || '-'}</td>
//                       <td>{order.delivery_number || '-'}</td>
//                       <td>{order.invoice_number || '-'}</td>
//                       <td>{formatMoney(order.total_value || 0, order.currency || draft.currency)}</td>
//                       <td>{formatDate(order.created_at)}</td>
//                       <td>
//                         {(String(order.status || '').toLowerCase() === 'pending_approval' ||
//                           String(order.status || '').toLowerCase() === 'paused') ? (
//                           <div className="o2c-action-row">
//                             <button type="button" className="o2c-btn success"
//                               onClick={async () => { setSelectedOrderId(order.order_id); await handleDecision('approve'); }}
//                               disabled={detailLoading}>Approve</button>
//                             <button type="button" className="o2c-btn danger"
//                               onClick={async () => { setSelectedOrderId(order.order_id); await handleDecision('reject'); }}
//                               disabled={detailLoading}>Reject</button>
//                           </div>
//                         ) : (
//                           <button type="button" className="o2c-btn"
//                             onClick={async () => { setSelectedOrderId(order.order_id); await loadOrderDetail(order.order_id); await handleReprocess(); }}
//                             disabled={detailLoading}>Re-Process</button>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </section>

//           {/* Action log */}
//           {detail?.result?.actions_taken?.length > 0 && (
//             <div className="o2c-action-log o2c-animate-in">
//               <h4>Latest Workflow Actions</h4>
//               <ul>
//                 {detail.result.actions_taken.map((item, idx) => (
//                   <li key={`${item}-${idx}`}>{item}</li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>
//       )}

//       {/* ── Toast ── */}
//       {toastMessage && (
//         <div className="o2c-toast">
//           <IconCheck />
//           {toastMessage}
//         </div>
//       )}
//     </div>
//   );
// };

// export default O2CAgent;


import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import '../Styles/O2CAgent.css';
import {
  ingestPurchaseOrder,
  confirmIngestedPurchaseOrder,
  getOrders,
  getOrderDetail,
  processOrder,
  approveOrder,
  login,
  getToken,
  getCurrentUser,
  setAuthData,
  clearAuth,
  canUpload,
  canApproveAny,
  canCreditApprove,
  canPricingApprove,
} from '../utils/o2cApi';

const EMPTY_DRAFT = {
  customer_id: '',
  po_number: '',
  currency: 'USD',
  lines: [],
};

const PAGE_META = {
  upload: {
    title: 'Upload Purchase Order',
    subtitle: 'Drop a customer PO document and scan for extraction.',
  },
  tracker: {
    title: 'Review Purchase Order',
    subtitle: 'Validate extracted values against source and confirm.',
  },
  dashboard: {
    title: 'Process Dashboard',
    subtitle: 'Track all submitted purchase orders and approvals.',
  },
};

function asNum(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

function formatMoney(value, currency = 'USD') {
  const amount = Number(value) || 0;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (_err) {
    return `${currency || 'USD'} ${amount.toFixed(2)}`;
  }
}

function formatDate(value) {
  if (!value) return '-';
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return value;
  return dt.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function getStatusTone(status) {
  const s = String(status || '').toLowerCase();
  if (/invoice/.test(s) || s === 'invoiced') return 'success';
  if (/reject/.test(s)) return 'danger';
  if (s === 'credit_hold' || s === 'pricing_hold') return 'danger';
  if (/pause|pending/.test(s)) return 'warn';
  if (/process|created/.test(s)) return 'info';
  return 'muted';
}

function statusLabel(status) {
  const s = String(status || '').toLowerCase();
  if (!s) return 'unknown';
  return s.replace(/_/g, ' ');
}

/* ─── SVG Icons ────────────────────────────────────────────── */
const IconUpload = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 16 12 12 8 16" />
    <line x1="12" y1="12" x2="12" y2="21" />
    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
  </svg>
);

const IconCheck = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const IconRefresh = ({ spinning }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ animation: spinning ? 'o2cSpin 0.8s linear infinite' : 'none' }}>
    <polyline points="23 4 23 10 17 10" />
    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
  </svg>
);

const IconArrowLeft = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const IconSearch = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const IconFile = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);

const IconPlus = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const IconTrash = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const IconFilter = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);

const IconAlert = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const IconBox = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

/* ─── Step Indicator ───────────────────────────────────────── */
const STEPS = ['Upload PO', 'Review & Edit', 'Dashboard'];
const StepIndicator = ({ current }) => {
  const idx = current === 'upload' ? 0 : current === 'tracker' ? 1 : 2;
  return (
    <div className="o2c-steps">
      {STEPS.map((label, i) => (
        <React.Fragment key={label}>
          <div className={`o2c-step ${i < idx ? 'past' : i === idx ? 'current' : ''}`}>
            <div className="o2c-step-circle">
              {i < idx ? <IconCheck /> : <span>{i + 1}</span>}
            </div>
            <span className="o2c-step-label">{label}</span>
          </div>
          {i < STEPS.length - 1 && (
            <div className={`o2c-step-line ${i < idx ? 'done' : ''}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

/* ─── Login pipeline SVG icons ─────────────────────────────── */
const PipeIcon = ({ d, extra }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {d}{extra}
  </svg>
);

const O2C_PIPELINE_STEPS = [
  {
    label: 'PO Upload',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 12 15 15"/></svg>,
  },
  {
    label: 'AI Scan',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/><path d="M7 8h.01M17 8h.01M12 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/></svg>,
  },
  {
    label: 'SAP SO',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>,
  },
  {
    label: 'Delivery',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
  },
  {
    label: 'Invoice',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/></svg>,
  },
];

const O2C_LOGIN_METRICS = [
  { label: 'Orders Automated',  val: '98%',  delta: 'End-to-end pipeline', pct: 98,  color: '#60a5fa' },
  { label: 'SAP Integration',   val: 'Live', delta: 'Real-time sync',       pct: 100, color: '#34d399' },
  { label: 'Avg Cycle Time',    val: '< 2m', delta: 'SO to Invoice',        pct: 85,  color: '#fbbf24' },
];

/* ─── File Preview ─────────────────────────────────────────── */
const FilePreview = ({ file }) => {
  const [previewUrl, setPreviewUrl]   = useState(null);
  const [xlsxSheets, setXlsxSheets]   = useState(null);
  const [activeSheet, setActiveSheet] = useState(0);

  useEffect(() => {
    if (!file) { setPreviewUrl(null); setXlsxSheets(null); return; }

    const name = file.name?.toLowerCase() || '';
    const isExcel = name.endsWith('.xlsx') || name.endsWith('.xls') || name.endsWith('.csv');

    if (isExcel) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const wb = XLSX.read(e.target.result, { type: 'array' });
          const sheets = wb.SheetNames.map((sheetName) => {
            const rows = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { header: 1, defval: '' });
            const headers = (rows[0] || []).map((h, i) => ({
              key: String(i),
              name: h !== '' ? String(h) : `Col ${i + 1}`,
              width: 140,
              resizable: true,
            }));
            const gridRows = rows.slice(1).map((row) =>
              Object.fromEntries(headers.map((col, i) => [col.key, row[i] ?? '']))
            );
            return { name: sheetName, columns: headers, rows: gridRows };
          });
          setXlsxSheets(sheets);
          setActiveSheet(0);
        } catch (_) {
          setXlsxSheets(null);
        }
      };
      reader.readAsArrayBuffer(file);
      return;
    }

    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  if (!file) {
    return (
      <div className="o2c-preview-placeholder">
        <div className="o2c-preview-icon"><IconBox /></div>
        <strong>No document selected</strong>
      </div>
    );
  }

  const isPdf   = file.type === 'application/pdf' || file.name?.toLowerCase().endsWith('.pdf');
  const isImage = file.type.startsWith('image/');

  if (xlsxSheets) {
    const sheet = xlsxSheets[activeSheet];
    return (
      <div className="o2c-preview-xlsx">
        {xlsxSheets.length > 1 && (
          <div className="o2c-xlsx-tabs">
            {xlsxSheets.map((s, i) => (
              <button key={i} className={`o2c-xlsx-tab${i === activeSheet ? ' active' : ''}`} onClick={() => setActiveSheet(i)}>
                {s.name}
              </button>
            ))}
          </div>
        )}
        <div className="o2c-xlsx-grid-wrap">
          <div className="o2c-xlsx-datagrid">
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr>
                  {sheet.columns.map(col => (
                    <th
                      key={col.key}
                      style={{
                        minWidth: col.width || 140, height: 36, padding: '0 8px',
                        borderBottom: '2px solid #d0d7e3', borderRight: '1px solid #d0d7e3',
                        textAlign: 'left', fontWeight: 600, whiteSpace: 'nowrap',
                        position: 'sticky', top: 0, background: '#f5f7fa', zIndex: 1,
                      }}
                    >
                      {col.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sheet.rows.map((row, idx) => (
                  <tr key={idx} style={{ height: 32 }}>
                    {sheet.columns.map(col => (
                      <td
                        key={col.key}
                        style={{
                          padding: '0 8px', maxWidth: col.width || 140,
                          borderBottom: '1px solid #e8edf4', borderRight: '1px solid #e8edf4',
                          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                        }}
                      >
                        {row[col.key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  if (isPdf && previewUrl) {
    return <iframe src={previewUrl} className="o2c-preview-frame" title="PO Preview" />;
  }

  if (isImage && previewUrl) {
    return (
      <div className="o2c-preview-img-wrap">
        <img src={previewUrl} alt="PO Preview" className="o2c-preview-img" />
      </div>
    );
  }

  return (
    <div className="o2c-preview-placeholder">
      <div className="o2c-preview-icon"><IconBox /></div>
      <strong>{file.name}</strong>
      <p>Preview not available for this file type.</p>
    </div>
  );
};

/* ─── Login screen ─────────────────────────────────────────── */
const O2CLogin = ({ onLogin }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [focusedField, setFocusedField] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) { setError('Username and password are required.'); return; }
    setLoading(true);
    setError('');
    try {
      const data = await login(username.trim(), password);
      setAuthData(data.access_token, { role: data.role, full_name: data.full_name });
      onLogin();
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="o2c-login-page">

      {/* ── Left branding panel ── */}
      <div className="o2c-login-left">
        {/* Animated background layers */}
        <div className="o2c-login-bg-mesh" />
        <div className="o2c-login-dotgrid" />
        <div className="o2c-login-orb o2c-login-orb-1" />
        <div className="o2c-login-orb o2c-login-orb-2" />
        <div className="o2c-login-orb o2c-login-orb-3" />
        <div className="o2c-login-orb o2c-login-orb-4" />

        {/* Top: brand */}
        <div className="o2c-login-brand">
          <div className="o2c-login-logo">
            <div className="o2c-login-logo-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
              </svg>
            </div>
            <span className="o2c-login-logo-text">SAVI AI</span>
            <span className="o2c-login-logo-badge">O2C Agent</span>
          </div>

          <div>
            <div className="o2c-login-module-label">Order-to-Cash Agent</div>
            <h1 className="o2c-login-tagline">
              From PO to Invoice,<br />
              <span className="o2c-login-tagline-accent">Fully Automated.</span>
            </h1>
          </div>

          <div className="o2c-login-features">
            {[
              {
                icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 12 15 15"/></svg>,
                text: 'AI-powered PO extraction — PDF, Excel, image',
              },
              {
                icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>,
                text: 'Automatic SAP Sales Order creation',
              },
              {
                icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>,
                text: 'Credit & pricing approval workflows',
              },
              {
                icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
                text: 'Delivery & invoice automation',
              },
            ].map((f, i) => (
              <div className="o2c-login-feature-row" key={i} style={{ animationDelay: `${0.3 + i * 0.1}s` }}>
                <span className="o2c-login-feature-icon">{f.icon}</span>
                <span>{f.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Middle: pipeline flow */}
        <div className="o2c-login-pipeline">
          <div className="o2c-login-pipeline-label">O2C PIPELINE</div>
          <div className="o2c-login-pipeline-steps">
            {O2C_PIPELINE_STEPS.map((step, i) => (
              <React.Fragment key={step.label}>
                <div className="o2c-login-pipeline-step" style={{ animationDelay: `${0.5 + i * 0.12}s` }}>
                  <div className="o2c-login-pipeline-dot">{step.icon}</div>
                  <span>{step.label}</span>
                </div>

                {i < O2C_PIPELINE_STEPS.length - 1 && (
                  <div className="o2c-login-pipeline-connector" style={{ animationDelay: `${0.62 + i * 0.12}s` }} />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Bottom: metric cards */}
        <div className="o2c-login-metrics">
          {O2C_LOGIN_METRICS.map((m, i) => (
            <div className="o2c-login-metric-card" key={m.label} style={{ animationDelay: `${0.4 + i * 0.15}s` }}>
              <div className="o2c-login-metric-left">
                <div className="o2c-login-metric-label">{m.label}</div>
                <div className="o2c-login-metric-val">{m.val}</div>
                <div className="o2c-login-metric-delta">{m.delta}</div>
              </div>
              <div className="o2c-login-metric-bar-wrap">
                <div className="o2c-login-metric-bar" style={{ '--pct': `${m.pct}%`, '--bar-color': m.color }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Right form panel ── */}
      <div className="o2c-login-right">
        <div className="o2c-login-card">

          <button type="button" className="o2c-login-back" onClick={() => navigate('/home')}>
            <IconArrowLeft /> Back to Home
          </button>

          {/* Form logo */}
          <div className="o2c-login-form-logo">
            <div className="o2c-login-form-logo-icon">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
              </svg>
            </div>
          </div>

          <div className="o2c-login-form-header">
            <h2>Welcome back</h2>
            <p>Sign in to your O2C Agent account</p>
          </div>

          <form onSubmit={handleSubmit} className="o2c-login-form">

            <div className={`o2c-login-field ${focusedField === 'username' ? 'focused' : ''}`}>
              <label>Username</label>
              <div className="o2c-login-input-wrap">
                <svg className="o2c-login-input-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
                <input
                  type="text"
                  autoComplete="username"
                  placeholder="e.g. ops_user"
                  value={username}
                  onChange={e => { setUsername(e.target.value); setError(''); }}
                  onFocus={() => setFocusedField('username')}
                  onBlur={() => setFocusedField('')}
                  required
                  autoFocus
                  disabled={loading}
                />
              </div>
            </div>

            <div className={`o2c-login-field ${focusedField === 'password' ? 'focused' : ''}`}>
              <label>Password</label>
              <div className="o2c-login-input-wrap">
                <svg className="o2c-login-input-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                <input
                  type="password"
                  autoComplete="current-password"
                  placeholder="••••••••"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setError(''); }}
                  onFocus={() => setFocusedField('password')}
                  onBlur={() => setFocusedField('')}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            {error && (
              <div className="o2c-login-err">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {error}
              </div>
            )}

            <button className="o2c-login-btn" type="submit" disabled={loading}>
              {loading ? (
                <span className="o2c-login-dots"><span/><span/><span/></span>
              ) : (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/>
                  </svg>
                  Sign in to SAVI
                </>
              )}
            </button>
          </form>

          <div className="o2c-login-trust">
            <span>🔒 Enterprise-grade security</span>
            <span>·</span>
            <span>SAP Certified</span>
            <span>·</span>
            <span>ISO 27001</span>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ─── Count-up number animation ───────────────────────────── */
const CountUp = ({ target, duration = 1100 }) => {
  const [count, setCount] = useState(0);
  const raf = useRef(null);
  useEffect(() => {
    setCount(0);
    if (!target) return;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 4); // easeOutQuart
      setCount(Math.round(eased * target));
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [target, duration]);
  return <>{count}</>;
};

/* ─── Ripple on button click ───────────────────────────────── */
const useRipple = () =>
  useCallback((e) => {
    const btn = e.currentTarget;
    const rect = btn.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 2.2;
    const span = document.createElement('span');
    span.className = 'o2c-ripple';
    Object.assign(span.style, {
      width:  `${size}px`,
      height: `${size}px`,
      left:   `${e.clientX - rect.left - size / 2}px`,
      top:    `${e.clientY - rect.top  - size / 2}px`,
    });
    btn.appendChild(span);
    span.addEventListener('animationend', () => span.remove());
  }, []);

/* ─── 3-D tilt on stat cards ───────────────────────────────── */
const useTilt = () => {
  const ref = useRef(null);
  const onMove = useCallback((e) => {
    const el = ref.current;
    if (!el) return;
    const { left, top, width, height } = el.getBoundingClientRect();
    const x = (e.clientX - left) / width  - 0.5;
    const y = (e.clientY - top)  / height - 0.5;
    el.style.transform = `perspective(520px) rotateX(${(-y * 10).toFixed(2)}deg) rotateY(${(x * 10).toFixed(2)}deg) translateY(-4px) scale(1.02)`;
  }, []);
  const onLeave = useCallback(() => {
    if (ref.current) ref.current.style.transform = '';
  }, []);
  return { ref, onMouseMove: onMove, onMouseLeave: onLeave };
};

/* ─── Tilt-enabled stat card ───────────────────────────────── */
const StatCard = ({ label, value, sub, colorClass, delay }) => {
  const tilt = useTilt();
  return (
    <div
      className={`o2c-stat o2c-stat-enter`}
      style={{ '--delay': delay, transition: 'transform .18s ease, box-shadow .18s' }}
      {...tilt}
    >
      <div className={`o2c-stat-icon ${colorClass}`} />
      <div className="o2c-stat-text">
        <p>{label}</p>
        <strong><CountUp target={value} /></strong>
        <small>{sub}</small>
      </div>
    </div>
  );
};

/* ─── Skeleton row ─────────────────────────────────────────── */
const SkeletonRow = ({ cols = 10 }) => (
  <tr className="o2c-skeleton-row">
    {Array.from({ length: cols }).map((_, i) => (
      <td key={i}><div className="o2c-skeleton" /></td>
    ))}
  </tr>
);

/* ─── Message cleaner ──────────────────────────────────────── */
function cleanMsg(msg) {
  if (!msg) return '';
  // Strip Python enum prefixes: "OrderStatus.CREDIT_HOLD" → "Credit Hold"
  return msg.replace(/\b\w+Status\.(\w+)/gi, (_, s) =>
    s.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
  );
}

/* ─── Approval helpers ─────────────────────────────────────── */
function resolveApproval(order) {
  const status = String(order?.status || '').toLowerCase();
  const interruptType = order?.pending_interrupt_type ||
    (status === 'credit_hold'  ? 'credit_approval_required'  : '') ||
    (status === 'pricing_hold' ? 'pricing_approval_required' : '');
  const roleRequired = order?.role_required ||
    (status === 'credit_hold'  ? 'credit_approver'  : '') ||
    (status === 'pricing_hold' ? 'pricing_approver' : '');
  const userRole = getCurrentUser()?.role || '';
  return {
    canAct:       roleRequired ? userRole === roleRequired : canApproveAny(),
    approveLabel: interruptType === 'pricing_approval_required' ? 'Approve Pricing' : 'Approve Credit',
    interruptType,
    roleRequired,
  };
}

/* ─── Order Detail Panel ───────────────────────────────────── */
const OrderDetailPanel = ({ order, detail, detailLoading, onClose, onApprove, onReject, onReprocess }) => {
  if (!order) return null;

  const isPending = ['pending_approval', 'paused', 'credit_hold', 'pricing_hold'].includes(String(order.status || '').toLowerCase());

  // Normalise detail fields — try all known backend nesting paths
  const d = detail || {};
  const actionsLog  = d?.result?.actions_taken || d?.actions_taken || [];
  const approvalMsg = d?.approval_message      || d?.result?.approval_message || order?.approval_message || '';

  const { canAct, approveLabel, interruptType } = resolveApproval(order);

  // Walk every plausible nesting path the API might use
  const lines = (
    d?.lines              ||
    d?.line_items         ||
    d?.items              ||
    d?.result?.lines      ||
    d?.result?.line_items ||
    d?.result?.items      ||
    d?.result?.order?.lines      ||
    d?.result?.order?.line_items ||
    d?.order?.lines       ||
    d?.order?.line_items  ||
    d?.data?.lines        ||
    d?.data?.line_items   ||
    order?.lines          ||
    order?.line_items     ||
    []
  ).filter(Boolean);

  // Normalise a single line item — handles snake_case and camelCase field names
  const normLine = (line, i) => ({
    no:         line.line_no      ?? line.lineNo      ?? line.line_number ?? line.LineNumber ?? (i + 1),
    material:   line.material_id  ?? line.materialId  ?? line.material    ?? line.Material   ?? '-',
    quantity:   line.quantity     ?? line.qty         ?? line.OrderQuantity ?? line.Quantity  ?? '-',
    uom:        line.uom          ?? line.UOM         ?? line.unit         ?? '-',
    unitPrice:  line.unit_price   ?? line.unitPrice   ?? line.UnitPrice   ?? null,
    listPrice:  line.list_price   ?? line.listPrice   ?? line.ListPrice   ?? null,
    lineTotal:  line.line_total   ?? line.lineTotal   ?? line.LineTotal   ?? line.net_value  ?? null,
  });

  return (
    <div className="o2c-detail-overlay" onClick={onClose}>
      <div className="o2c-detail-panel" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="o2c-dp-header">
          <div className="o2c-dp-title">
            <h2>{order.order_id}</h2>
            <div className="o2c-dp-meta">
              {order.customer_id && <span>{order.customer_id}</span>}
              {order.currency    && <><span className="o2c-dp-dot">·</span><span>{order.currency}</span></>}
              <span className={`o2c-status o2c-status-${getStatusTone(order.status)}`}>
                {statusLabel(order.status)}
              </span>
            </div>
          </div>
          <button className="o2c-dp-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        {detailLoading && (
          <div className="o2c-dp-loading">
            <span className="o2c-spinner" style={{ width: 20, height: 20, borderWidth: 3 }} />
            <span>Loading detail…</span>
          </div>
        )}

        {!detailLoading && (
          <div className="o2c-dp-body">

            {/* Order info + SAP docs */}
            <div className="o2c-dp-grid2">
              <div className="o2c-dp-section">
                <div className="o2c-dp-section-title">📋 Order Info</div>
                <div className="o2c-dp-rows">
                  <div className="o2c-dp-row"><span>Order ID</span><strong>{order.order_id}</strong></div>
                  <div className="o2c-dp-row"><span>Customer</span><strong>{order.customer_id || '-'}</strong></div>
                  <div className="o2c-dp-row"><span>PO Number</span><strong>{order.po_number || '-'}</strong></div>
                  <div className="o2c-dp-row"><span>Currency</span><strong>{order.currency || '-'}</strong></div>
                  <div className="o2c-dp-row"><span>Total Value</span><strong>{formatMoney(order.total_value, order.currency)}</strong></div>
                  <div className="o2c-dp-row"><span>Created</span><strong>{formatDate(order.created_at)}</strong></div>
                  <div className="o2c-dp-row">
                    <span>Status</span>
                    <span className={`o2c-status o2c-status-${getStatusTone(order.status)}`}>
                      {statusLabel(order.status)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="o2c-dp-section">
                <div className="o2c-dp-section-title">🗂 SAP Documents</div>
                <div className="o2c-dp-rows">
                  <div className="o2c-dp-row"><span>Sales Order</span><strong className="o2c-dp-doc">{order.sap_so_number || '-'}</strong></div>
                  <div className="o2c-dp-row"><span>Delivery</span><strong className="o2c-dp-doc">{order.delivery_number || '-'}</strong></div>
                  <div className="o2c-dp-row"><span>Invoice</span><strong className="o2c-dp-doc">{order.invoice_number || '-'}</strong></div>
                </div>
              </div>
            </div>

            {/* Process log */}
            {actionsLog.length > 0 && (
              <div className="o2c-dp-section">
                <div className="o2c-dp-section-title">⚡ Process Log</div>
                <ul className="o2c-dp-log">
                  {actionsLog.map((item, i) => (
                    <li key={i}><span className="o2c-dp-log-check">✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            {/* Approval / pause message */}
            {isPending && (
              <div className="o2c-dp-approval-msg">
                {interruptType && (
                  <span className="o2c-dp-interrupt-badge">
                    {interruptType === 'pricing_approval_required' ? 'Pricing Escalation' : 'Credit Hold'}
                  </span>
                )}
                {approvalMsg || 'Order paused by the agent and waiting for decision.'}
              </div>
            )}

            {/* Line items */}
            {lines.length > 0 && (
              <div className="o2c-dp-section">
                <div className="o2c-dp-section-title">≡ Line Items</div>
                <div className="o2c-dp-table-wrap">
                  <table className="o2c-dp-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Material</th>
                        <th>QTY</th>
                        <th>UOM</th>
                        <th>Unit Price</th>
                        <th>List Price</th>
                        <th>Line Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lines.map((line, i) => {
                        const n = normLine(line, i);
                        return (
                          <tr key={i}>
                            <td>{n.no}</td>
                            <td>{n.material}</td>
                            <td>{n.quantity}</td>
                            <td>{n.uom}</td>
                            <td>{n.unitPrice != null ? formatMoney(n.unitPrice, order.currency) : '-'}</td>
                            <td>{n.listPrice != null ? formatMoney(n.listPrice, order.currency) : '-'}</td>
                            <td>{n.lineTotal != null ? formatMoney(n.lineTotal, order.currency) : '-'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Action buttons */}
            {isPending ? (
              canAct ? (
                <div className="o2c-dp-actions">
                  <button className="o2c-btn success" onClick={onApprove} disabled={detailLoading}>{approveLabel}</button>
                  <button className="o2c-btn danger"  onClick={onReject}  disabled={detailLoading}>Reject Order</button>
                </div>
              ) : (
                <div className="o2c-dp-actions">
                  <span style={{ fontSize: '0.82rem', color: 'var(--sub)' }}>
                    Awaiting approval by a {order?.role_required?.replace(/_/g, ' ') || 'designated approver'}.
                  </span>
                </div>
              )
            ) : (
              canUpload() && (
                <div className="o2c-dp-actions">
                  <button className="o2c-btn" onClick={onReprocess} disabled={detailLoading}>
                    {detailLoading ? <><span className="o2c-spinner" /> Processing…</> : 'Re-Process'}
                  </button>
                </div>
              )
            )}

          </div>
        )}
      </div>
    </div>
  );
};

/* ─── Main component ───────────────────────────────────────── */
const O2CAgent = () => {
  const ripple = useRipple();
  const navigate = useNavigate();
  const location = useLocation();
  const [authed, setAuthed] = useState(false);
  const [user, setUser]     = useState(null);
  const [activePage, setActivePage] = useState('upload');
  const [file, setFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const [ingestLoading, setIngestLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [ingestResult, setIngestResult] = useState(null);
  const [draft, setDraft] = useState(EMPTY_DRAFT);
  const [confirmResult, setConfirmResult] = useState(null);

  const [orders, setOrders] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState('');
  const [detail, setDetail] = useState(null);
  const [toastMessage, setToastMessage] = useState('');
  const [showDetail, setShowDetail] = useState(false);

  /* search + filter */
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const selectedOrder = useMemo(
    () => orders.find((o) => o.order_id === selectedOrderId) || null,
    [orders, selectedOrderId]
  );

  const draftTotal = useMemo(
    () => (draft.lines || []).reduce((sum, line) => sum + (asNum(line.quantity) * asNum(line.unit_price)), 0),
    [draft.lines]
  );

  const pageMeta = PAGE_META[activePage] || PAGE_META.upload;

  const dashboardStats = useMemo(() => {
    const byStatus = (orders || []).reduce((acc, order) => {
      const key = String(order?.status || 'unknown').toLowerCase();
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});
    const totalValue = (orders || []).reduce((sum, order) => sum + (Number(order?.total_value) || 0), 0);
    return {
      totalOrders: orders.length,
      processing: (byStatus.processing || 0) + (byStatus.created || 0),
      invoiced: byStatus.invoiced || 0,
      pendingApproval: (byStatus.pending_approval || 0) + (byStatus.paused || 0) + (byStatus.credit_hold || 0) + (byStatus.pricing_hold || 0),
      rejected: byStatus.rejected || 0,
      totalValue,
      byStatus,
    };
  }, [orders]);

  const approvalQueue = useMemo(
    () => orders.filter((o) => {
      const s = String(o?.status || '').toLowerCase();
      return s === 'pending_approval' || s === 'paused' || s === 'credit_hold' || s === 'pricing_hold';
    }),
    [orders]
  );

  const activeApprovalOrder = useMemo(() => {
    if (selectedOrderId) {
      const selected = approvalQueue.find((o) => o.order_id === selectedOrderId);
      if (selected) return selected;
    }
    return approvalQueue[0] || null;
  }, [approvalQueue, selectedOrderId]);

  const filteredOrders = useMemo(() => {
    const q = searchQuery.toLowerCase();
    return orders.filter((o) => {
      const matchSearch = !q ||
        (o.order_id || '').toLowerCase().includes(q) ||
        (o.customer_id || '').toLowerCase().includes(q) ||
        (o.po_number || '').toLowerCase().includes(q) ||
        (o.sap_so_number || '').toLowerCase().includes(q);
      const matchStatus = statusFilter === 'all' ||
        String(o.status || '').toLowerCase().includes(statusFilter);
      return matchSearch && matchStatus;
    });
  }, [orders, searchQuery, statusFilter]);

  const updateHeader = (field, value) => {
    setDraft((prev) => ({ ...prev, [field]: value }));
  };

  const updateLine = (index, field, value) => {
    setDraft((prev) => ({
      ...prev,
      lines: prev.lines.map((line, idx) => {
        if (idx !== index) return line;
        if (['line_no', 'quantity', 'unit_price'].includes(field)) {
          return { ...line, [field]: asNum(value) };
        }
        return { ...line, [field]: value };
      }),
    }));
  };

  const addLine = () => {
    setDraft((prev) => ({
      ...prev,
      lines: [
        ...prev.lines,
        { line_no: prev.lines.length + 1, material_id: '', quantity: 1, unit_price: 0, uom: 'EA' },
      ],
    }));
  };

  const removeLine = (index) => {
    setDraft((prev) => ({
      ...prev,
      lines: prev.lines
        .filter((_, idx) => idx !== index)
        .map((line, idx) => ({ ...line, line_no: idx + 1 })),
    }));
  };

  const clearMessages = () => { setError(''); setSuccess(''); };

  const loadOrderDetail = async (orderId) => {
    if (!orderId) return;
    setDetailLoading(true);
    setError('');
    try {
      const data = await getOrderDetail(orderId);
      setDetail(data);
    } catch (err) {
      setError(err.message || 'Failed to load order detail');
    } finally {
      setDetailLoading(false);
    }
  };

  const refreshOrders = async (preferredId) => {
    setOrdersLoading(true);
    setError('');
    try {
      const data = await getOrders();
      const list = Array.isArray(data?.orders) ? data.orders : [];
      setOrders(list);
      const nextId = preferredId || selectedOrderId || list[0]?.order_id || '';
      setSelectedOrderId(nextId);
      if (nextId) {
        await loadOrderDetail(nextId);
      } else {
        setDetail(null);
      }
    } catch (err) {
      setError(err.message || 'Failed to load orders');
    } finally {
      setOrdersLoading(false);
    }
  };

  const handleIngest = async () => {
    if (!file) { setError('Select a file first.'); return; }
    setIngestLoading(true);
    clearMessages();
    setConfirmResult(null);
    try {
      const data = await ingestPurchaseOrder(file);
      setIngestResult(data);
      setDraft(data?.draft_order || data?.extracted || EMPTY_DRAFT);
      setSuccess(data?.message || 'PO extracted successfully. Review and confirm.');
      setToastMessage('PO extracted. Review fields and confirm when ready.');
      navigate('/o2c-agent/tracker');
    } catch (err) {
      setError(err.message || 'Failed to ingest PO');
    } finally {
      setIngestLoading(false);
    }
  };

  const handleConfirm = async () => {
    if (!draft.customer_id || !draft.po_number || !draft.currency || draft.lines.length === 0) {
      setError('Customer ID, PO number, currency, and at least one line are required.');
      return;
    }
    const normalizedLines = (draft.lines || [])
      .map((line, idx) => ({
        line_no: asNum(line.line_no) || idx + 1,
        material_id: String(line.material_id || '').trim(),
        quantity: asNum(line.quantity),
        unit_price: asNum(line.unit_price),
        uom: String(line.uom || '').trim() || 'EA',
      }))
      .filter((line) => line.material_id);
    if (normalizedLines.length === 0) {
      setError('At least one line with a material ID is required.');
      return;
    }
    const invalidLine = normalizedLines.find((l) => l.quantity <= 0 || l.unit_price < 0);
    if (invalidLine) {
      setError(`Invalid values in line ${invalidLine.line_no}.`);
      return;
    }
    const payload = {
      customer_id: String(draft.customer_id).trim(),
      po_number: String(draft.po_number).trim(),
      currency: String(draft.currency).trim().toUpperCase(),
      lines: normalizedLines,
    };
    setConfirmLoading(true);
    clearMessages();
    try {
      const data = await confirmIngestedPurchaseOrder(payload);
      setConfirmResult(data);
      setSuccess(cleanMsg(data?.message) || 'PO processed successfully');
      await refreshOrders(data?.order_id);
      setToastMessage(`${data?.order_id || 'Order'} submitted to O2C pipeline.`);
      navigate('/o2c-agent/dashboard');
    } catch (err) {
      setError(err.message || 'Failed to confirm PO');
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleReprocess = async () => {
    if (!selectedOrderId) return;
    setDetailLoading(true);
    clearMessages();
    try {
      const data = await processOrder(selectedOrderId);
      setSuccess(cleanMsg(data?.message) || 'Order processed successfully');
      await loadOrderDetail(selectedOrderId);
      await refreshOrders(selectedOrderId);
      setToastMessage(`${selectedOrderId} re-processed successfully.`);
    } catch (err) {
      setError(err.message || 'Failed to process order');
    } finally {
      setDetailLoading(false);
    }
  };

  const handleDecision = async (decision) => {
    if (!selectedOrderId) return;
    setDetailLoading(true);
    clearMessages();
    try {
      const data = await approveOrder(selectedOrderId, decision);
      setSuccess(cleanMsg(data?.message) || `Order ${decision}d successfully`);
      await loadOrderDetail(selectedOrderId);
      await refreshOrders(selectedOrderId);
      setToastMessage(`${selectedOrderId} ${decision === 'approve' ? 'approved ✓' : 'rejected'}.`);
    } catch (err) {
      const msg = err.message || '';
      if (msg.includes('409') || msg.toLowerCase().includes('not awaiting approval')) {
        setError('This order is in a SAP hard-block state (Credit Hold). The backend must move it to Pending Approval before it can be actioned here.');
      } else {
        setError(msg || `Failed to ${decision} order`);
      }
    } finally {
      setDetailLoading(false);
    }
  };

  // ── Auth init ──
  useEffect(() => {
    if (getToken()) {
      setAuthed(true);
      setUser(getCurrentUser());
    }
  }, []);

  useEffect(() => {
    const handleLogout = () => { setAuthed(false); setUser(null); };
    window.addEventListener('o2c:logout', handleLogout);
    return () => window.removeEventListener('o2c:logout', handleLogout);
  }, []);

  const handleLogin = () => {
    setAuthed(true);
    setUser(getCurrentUser());
  };

  const handleLogout = () => {
    clearAuth();
    setAuthed(false);
    setUser(null);
  };

  useEffect(() => {
    if (location.pathname.endsWith('/dashboard')) { setActivePage('dashboard'); return; }
    if (location.pathname.endsWith('/tracker'))   { setActivePage('tracker');   return; }
    setActivePage('upload');
  }, [location.pathname]);

  useEffect(() => {
    if ((activePage === 'dashboard' || activePage === 'tracker') && orders.length === 0) {
      refreshOrders();
    }
  }, [activePage]);

  useEffect(() => {
    if (!toastMessage) return undefined;
    const timer = setTimeout(() => setToastMessage(''), 3400);
    return () => clearTimeout(timer);
  }, [toastMessage]);

  useEffect(() => {
    if (activeApprovalOrder?.order_id) setSelectedOrderId(activeApprovalOrder.order_id);
  }, [activeApprovalOrder?.order_id]);

  const handleRowClick = async (orderId) => {
    setSelectedOrderId(orderId);
    setShowDetail(true);
    await loadOrderDetail(orderId);
  };

  const navigateToPage = (page) => {
    navigate(page === 'dashboard' ? '/o2c-agent/dashboard' : page === 'tracker' ? '/o2c-agent/tracker' : '/o2c-agent/upload');
  };

  const triggerFilePicker = () => fileInputRef.current?.click();

  const onFileSelected = (selected) => {
    if (!selected) return;
    setFile(selected);
    setIngestResult(null);
    clearMessages();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);
    const dropped = event.dataTransfer?.files?.[0];
    if (dropped) onFileSelected(dropped);
  };

  /* file extension helper */
  const fileExt = file ? file.name.split('.').pop().toUpperCase() : null;

  if (!authed) return <O2CLogin onLogin={handleLogin} />;

  const roleName    = (user?.role || '').replace(/_/g, ' ');
  const displayName = user?.full_name || user?.role || 'User';

  return (
    <div className="o2c-page">

      {/* ── Topbar ── */}
      <header className="o2c-topbar">
        <div className="o2c-title">
          <h1>{pageMeta.title}</h1>
          <p>{pageMeta.subtitle}</p>
        </div>
        <div className="o2c-topbar-actions">
          {user && (
            <div style={{ fontSize: '0.82rem', color: 'var(--sub)', textAlign: 'right', lineHeight: 1.3 }}>
              <div style={{ fontWeight: 700, color: 'var(--ink)' }}>{displayName}</div>
              <div style={{ fontSize: '0.74rem', textTransform: 'capitalize' }}>{roleName}</div>
            </div>
          )}
          <button type="button" className="o2c-btn" onClick={() => refreshOrders()} disabled={ordersLoading}>
            <IconRefresh spinning={ordersLoading} />
            {ordersLoading ? 'Refreshing…' : 'Refresh'}
          </button>
          <button type="button" className="o2c-btn" onClick={() => navigate('/home')}>
            <IconArrowLeft /> Back to Home
          </button>
          <button type="button" className="o2c-btn danger" onClick={handleLogout} title="Sign out">
            Sign Out
          </button>
        </div>
      </header>

      {/* ── Step indicator ── */}
      <StepIndicator current={activePage} />

      {/* ── Tab nav ── */}
      <nav className="o2c-page-nav" aria-label="O2C pages">
        {[
          { id: 'upload',    label: 'Upload Purchase Order', icon: '📄', show: canUpload() },
          { id: 'tracker',   label: 'Review Purchase Order', icon: '✏️', show: canUpload() },
          { id: 'dashboard', label: 'Process Dashboard',     icon: '📊', show: true },
        ].filter(t => t.show).map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`o2c-page-btn ${activePage === tab.id ? 'active' : ''}`}
            onClick={() => navigateToPage(tab.id)}
          >
            {tab.icon}{' '}{tab.label}
            {tab.id === 'dashboard' && orders.length > 0 && (
              <span className="o2c-tab-badge">{orders.length}</span>
            )}
          </button>
        ))}
      </nav>

      {/* ── Messages ── */}
      {error   && <div className="o2c-error"   role="alert"><IconAlert />{error}</div>}
      {success && <div className="o2c-success"  role="status"><IconCheck />{success}</div>}

      {/* ════════════════════════════════ UPLOAD PAGE ════════════════════════════════ */}
      {activePage === 'upload' && (
        <div className="o2c-card o2c-animate-in">
          <div className="o2c-card-head">
            <h2>Upload Purchase Order</h2>
            <p>Drop a customer PO document, review extracted fields side by side with source, then confirm before the O2C pipeline starts.</p>
          </div>

          <div className="o2c-upload-layout">
            {/* Drop zone panel */}
            <div className="o2c-upload-card">
              <h3>Drop Zone</h3>
              <div
                className={`o2c-drop-zone ${dragActive ? 'active' : ''} ${file && ingestResult ? 'has-scanned' : file ? 'has-file' : ''}`}
                onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); setDragActive(true); }}
                onDragOver={(e)  => { e.preventDefault(); e.stopPropagation(); setDragActive(true); }}
                onDragLeave={(e) => { e.preventDefault(); e.stopPropagation(); setDragActive(false); }}
                onDrop={handleDrop}
                onClick={triggerFilePicker}
                role="button"
                tabIndex={0}
              >
                {file ? (
                  <>
                    <div className="o2c-drop-icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                      </svg>
                    </div>
                    <h4 className="o2c-drop-filename">{file.name}</h4>
                    <p>{(file.size / 1024).toFixed(1)} KB · click to change file</p>
                  </>
                ) : (
                  <>
                    <div className={`o2c-drop-icon ${dragActive ? 'bounce' : ''}`}>
                      <IconUpload />
                    </div>
                    <h4>{dragActive ? 'Release to upload' : 'Drag & drop your PO here'}</h4>
                    <p>or click anywhere to browse</p>
                    <button type="button" className="o2c-btn primary" onClick={(e) => { e.stopPropagation(); triggerFilePicker(); }}>
                      Browse Files
                    </button>
                    <div className="o2c-file-tags">
                      {['PDF', 'PNG', 'JPG', 'XLSX', 'CSV'].map((t) => (
                        <span key={t}>{t}</span>
                      ))}
                    </div>
                  </>
                )}
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="application/pdf,image/*,.xlsx,.xls,.csv"
                  onChange={(e) => onFileSelected(e.target.files?.[0] || null)}
                  className="o2c-hidden-input"
                />
              </div>

              {file && (
                <div className="o2c-picked-file o2c-animate-in">
                  <div className="o2c-picked-file-info">
                    <div className="o2c-file-ext-badge">{fileExt}</div>
                    <span>{file.name}</span>
                  </div>
                  <small>{Math.max(1, Math.round(file.size / 1024))} KB</small>
                </div>
              )}

              <button
                type="button"
                className="o2c-btn dark-block"
                onClick={(e) => { ripple(e); handleIngest(); }}
                disabled={!file || ingestLoading}
              >
                {ingestLoading ? (
                  <><span className="o2c-spinner" />Uploading and scanning…</>
                ) : (
                  <><IconUpload /> Scan PO For Review</>
                )}
              </button>

              {(ingestLoading || ingestResult) && (
                <ol className="o2c-scan-steps">
                  <li className="done">Uploading and scanning document</li>
                  <li className={ingestResult ? 'done' : 'active'}>Preparing side-by-side review</li>
                  <li className={ingestResult ? 'done' : ''}>Waiting for user confirmation</li>
                </ol>
              )}
            </div>

            {/* How it works panel */}
            <div className="o2c-how-card">
              <h3>How It Works</h3>
              <ol>
                <li>
                  <strong>Upload PO Document</strong>
                  <p>Drop a PDF, image, or spreadsheet of any customer purchase order.</p>
                </li>
                <li>
                  <strong>AI Extraction</strong>
                  <p>The model extracts customer, PO number, line items, quantities, and prices.</p>
                </li>
                <li>
                  <strong>Review and Correct</strong>
                  <p>Validate extracted values, fix any OCR errors, and confirm final inputs.</p>
                </li>
                <li>
                  <strong>SAP Sales Order to Invoice</strong>
                  <p>After confirmation, O2C processes end-to-end and handles approvals if needed.</p>
                </li>
              </ol>
            </div>
          </div>
        </div>
      )}

      {/* ════════════════════════════════ TRACKER PAGE ═══════════════════════════════ */}
      {activePage === 'tracker' && (
        <div className="o2c-card o2c-animate-in">
          <div className="o2c-card-head">
            <h2>Review Purchase Order</h2>
            <p>Validate extracted values against the original PO, correct mistakes, and confirm when data looks right.</p>
          </div>

          <div className="o2c-review-file-row">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <IconFile />
              <span>{file?.name || ingestResult?.filename || 'No file uploaded yet'}</span>
            </div>
            <span className="o2c-line-count-badge">{draft.lines.length} line{draft.lines.length !== 1 ? 's' : ''}</span>
          </div>

          <div className="o2c-review-layout">
            {/* Left: original */}
            <section className="o2c-review-left">
              <header>
                <h3>Original Purchase Order</h3>
                <small>{file?.name || ingestResult?.filename || '-'}</small>
              </header>
              <FilePreview file={file} />
            </section>

            {/* Right: editable fields */}
            <section className="o2c-review-right">
              <header>
                <h3>Editable Extracted Fields</h3>
                <small>Used for sales order creation</small>
              </header>

              <div className="o2c-review-right-body">
              <p className="o2c-help-banner">
                Compare uploaded PO with extracted values and update as needed.
              </p>

              <div className="o2c-grid o2c-grid-header">
                <label className="o2c-label">
                  Customer ID
                  <input type="text" value={draft.customer_id || ''} onChange={(e) => updateHeader('customer_id', e.target.value)} placeholder="e.g. CUST-001" />
                </label>
                <label className="o2c-label">
                  PO Number
                  <input type="text" value={draft.po_number || ''} onChange={(e) => updateHeader('po_number', e.target.value)} placeholder="e.g. PO-2024-001" />
                </label>
                <label className="o2c-label" style={{ gridColumn: '1 / -1' }}>
                  Currency
                  <input type="text" maxLength={3} value={draft.currency || ''} onChange={(e) => updateHeader('currency', e.target.value.toUpperCase())} placeholder="USD" style={{ maxWidth: 120 }} />
                </label>
              </div>

              <div className="o2c-review-lines-title">
                <h4>Line Items ({draft.lines.length})</h4>
                <button type="button" className="o2c-btn" onClick={addLine}>
                  <IconPlus /> Add Line
                </button>
              </div>

              {(draft.lines || []).map((line, index) => (
                <div key={`${line.line_no}-${index}`} className="o2c-line-card o2c-line-enter">
                  <div className="o2c-line-card-head">
                    <span>Line {index + 1}</span>
                    <button type="button" className="o2c-btn danger icon-btn" onClick={() => removeLine(index)}>
                      <IconTrash />
                    </button>
                  </div>
                  <div className="o2c-line-grid">
                    <label className="o2c-label">
                      Line No
                      <input type="number" min="1" value={line.line_no} onChange={(e) => updateLine(index, 'line_no', e.target.value)} />
                    </label>
                    <label className="o2c-label">
                      Material ID
                      <input type="text" value={line.material_id || ''} onChange={(e) => updateLine(index, 'material_id', e.target.value)} placeholder="MAT-001" />
                    </label>
                    <label className="o2c-label">
                      Quantity
                      <input type="number" min="1" value={line.quantity} onChange={(e) => updateLine(index, 'quantity', e.target.value)} />
                    </label>
                    <label className="o2c-label">
                      Unit Price
                      <input type="number" min="0" step="0.01" value={line.unit_price} onChange={(e) => updateLine(index, 'unit_price', e.target.value)} />
                    </label>
                    <label className="o2c-label">
                      UOM
                      <input type="text" value={line.uom || ''} onChange={(e) => updateLine(index, 'uom', e.target.value)} placeholder="EA" />
                    </label>
                  </div>
                </div>
              ))}

              {draft.lines.length === 0 && (
                <p className="o2c-hint">No lines extracted yet. Click "Add Line" to add manually.</p>
              )}

              </div>{/* end o2c-review-right-body */}

              <div className="o2c-review-footer">
                <div className="o2c-total-display">
                  <span>Total</span>
                  <strong>{formatMoney(draftTotal, draft.currency)}</strong>
                </div>
                <div className="o2c-action-row">
                  <button type="button" className="o2c-btn" onClick={() => navigate('/o2c-agent/upload')}>
                    <IconArrowLeft /> Back
                  </button>
                  <button type="button" className="o2c-btn dark-block" onClick={(e) => { ripple(e); handleConfirm(); }} disabled={confirmLoading}>
                    {confirmLoading ? (
                      <><span className="o2c-spinner" />Confirming…</>
                    ) : (
                      <>Confirm & Start O2C</>
                    )}
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}

      {/* ════════════════════════════════ DASHBOARD PAGE ═════════════════════════════ */}
      {activePage === 'dashboard' && (
        <div className="o2c-card o2c-animate-in">
          <div className="o2c-card-head">
            <h2>Process Dashboard</h2>
            <p>Real-time O2C pipeline status for all submitted purchase orders.</p>
          </div>

          {/* Stats */}
          <div className="o2c-stats">
            <StatCard label="Total Orders"     value={dashboardStats.totalOrders}    sub="all time"    colorClass="c1" delay="0ms"   />
            <StatCard label="Processing"        value={dashboardStats.processing}     sub="in pipeline" colorClass="c2" delay="60ms"  />
            <StatCard label="Awaiting Approval" value={dashboardStats.pendingApproval} sub="need action" colorClass="c3" delay="120ms" />
            <StatCard label="Completed"         value={dashboardStats.invoiced}       sub="invoiced"    colorClass="c4" delay="180ms" />
            <StatCard label="Errors / Holds"    value={dashboardStats.rejected}       sub="need review" colorClass="c5" delay="240ms" />
          </div>

          {/* Approval queue */}
          {activeApprovalOrder && (
            <section className="o2c-approval-queue o2c-animate-in">
              <div className="o2c-approval-head">
                <h3><IconAlert /> Human Approval Required</h3>
                <span>{approvalQueue.length} waiting</span>
              </div>
              <div className="o2c-approval-item">
                <div>
                  <div className="o2c-approval-meta">
                    <strong>{activeApprovalOrder.order_id}</strong>
                    <span className={`o2c-status o2c-status-${getStatusTone(activeApprovalOrder.status)}`}>
                      {statusLabel(activeApprovalOrder.status)}
                    </span>
                  </div>
                  <p>
                    Customer <b>{activeApprovalOrder.customer_id || '-'}</b>
                    {' · '}PO <b>{activeApprovalOrder.po_number || '-'}</b>
                    {' · '}{(activeApprovalOrder.currency || 'USD')} {Number(activeApprovalOrder.total_value || 0).toLocaleString()}
                    {activeApprovalOrder.sap_so_number ? ` · SAP SO ${activeApprovalOrder.sap_so_number}` : ''}
                  </p>
                  <div className="o2c-approval-message">
                    {activeApprovalOrder.pending_interrupt_type && (
                      <span className="o2c-dp-interrupt-badge">
                        {activeApprovalOrder.pending_interrupt_type === 'pricing_approval_required' ? 'Pricing Escalation' : 'Credit Hold'}
                      </span>
                    )}
                    {activeApprovalOrder.approval_message || 'Order paused by the agent and waiting for decision.'}
                  </div>
                </div>
                {(() => {
                  const { canAct: canActQueue, approveLabel: queueApproveLabel } = resolveApproval(activeApprovalOrder);
                  return canActQueue ? (
                    <div className="o2c-approval-actions">
                      <button
                        type="button"
                        className="o2c-btn success"
                        onClick={async () => { setSelectedOrderId(activeApprovalOrder.order_id); await handleDecision('approve'); }}
                        disabled={detailLoading}
                      >
                        {detailLoading ? <span className="o2c-spinner" /> : null} {queueApproveLabel}
                      </button>
                      <button
                        type="button"
                        className="o2c-btn danger"
                        onClick={async () => { setSelectedOrderId(activeApprovalOrder.order_id); await handleDecision('reject'); }}
                        disabled={detailLoading}
                      >
                        Reject Order
                      </button>
                    </div>
                  ) : null;
                })()}
              </div>
            </section>
          )}

          {/* Orders table */}
          <section className="o2c-orders-block">
            <div className="o2c-orders-head">
              <h3>Orders</h3>
              <div className="o2c-table-controls">
                <div className="o2c-search-wrap">
                  <IconSearch />
                  <input
                    type="text"
                    className="o2c-search-input"
                    placeholder="Search orders…"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <div className="o2c-filter-wrap">
                  <IconFilter />
                  <select
                    className="o2c-filter-select"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    <option value="all">All Status</option>
                    <option value="created">Created</option>
                    <option value="processing">Processing</option>
                    <option value="pending">Pending Approval</option>
                    <option value="invoiced">Invoiced</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>
                <span className="o2c-orders-count">{filteredOrders.length} order{filteredOrders.length !== 1 ? 's' : ''}</span>
              </div>
            </div>

            <div className="o2c-table-wrap">
              <table className="o2c-table">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>PO Number</th>
                    <th>Status</th>
                    <th>SAP SO</th>
                    <th>Delivery</th>
                    <th>Invoice</th>
                    <th>Total Value</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {ordersLoading && (
                    <>
                      <SkeletonRow cols={10} />
                      <SkeletonRow cols={10} />
                      <SkeletonRow cols={10} />
                      <SkeletonRow cols={10} />
                    </>
                  )}
                  {!ordersLoading && filteredOrders.length === 0 && (
                    <tr>
                      <td colSpan={10}>
                        <div className="o2c-empty-state">
                          <div className="o2c-empty-icon"><IconBox /></div>
                          <strong>{orders.length === 0 ? 'No orders yet' : 'No results found'}</strong>
                          <p>{orders.length === 0 ? 'Upload and confirm a PO to populate the dashboard.' : 'Try adjusting your search or filter.'}</p>
                        </div>
                      </td>
                    </tr>
                  )}
                  {!ordersLoading && filteredOrders.map((order, idx) => (
                    <tr
                      key={order.order_id}
                      className="o2c-table-row-enter o2c-table-row-clickable"
                      style={{ '--row-delay': `${idx * 30}ms` }}
                      onClick={() => handleRowClick(order.order_id)}
                    >
                      <td className="o2c-order-link">{order.order_id}</td>
                      <td>{order.customer_id || '-'}</td>
                      <td>{order.po_number || '-'}</td>
                      <td>
                        <span className={`o2c-status o2c-status-${getStatusTone(order.status)}`}>
                          {statusLabel(order.status)}
                        </span>
                      </td>
                      <td>{order.sap_so_number || '-'}</td>
                      <td>{order.delivery_number || '-'}</td>
                      <td>{order.invoice_number || '-'}</td>
                      <td>{formatMoney(order.total_value || 0, order.currency || draft.currency)}</td>
                      <td>{formatDate(order.created_at)}</td>
                      <td>
                        {(['pending_approval', 'paused', 'credit_hold', 'pricing_hold'].includes(String(order.status || '').toLowerCase())) ? (
                          (() => {
                            const { canAct: canActRow, approveLabel: rowApproveLabel } = resolveApproval(order);
                            return canActRow ? (
                              <div className="o2c-action-row" onClick={(e) => e.stopPropagation()}>
                                <button type="button" className="o2c-btn success"
                                  onClick={async (e) => { e.stopPropagation(); setSelectedOrderId(order.order_id); await handleDecision('approve'); }}
                                  disabled={detailLoading}>{rowApproveLabel}</button>
                                <button type="button" className="o2c-btn danger"
                                  onClick={async (e) => { e.stopPropagation(); setSelectedOrderId(order.order_id); await handleDecision('reject'); }}
                                  disabled={detailLoading}>Reject Order</button>
                              </div>
                            ) : (
                              <span className="o2c-status o2c-status-warn">Awaiting Approval</span>
                            );
                          })()
                        ) : (
                          canUpload() && (
                            <button type="button" className="o2c-btn"
                              onClick={async (e) => { e.stopPropagation(); setSelectedOrderId(order.order_id); await loadOrderDetail(order.order_id); await handleReprocess(); }}
                              disabled={detailLoading}>Re-Process</button>
                          )
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          {/* Action log */}
          {detail?.result?.actions_taken?.length > 0 && (
            <div className="o2c-action-log o2c-animate-in">
              <h4>Latest Workflow Actions</h4>
              <ul>
                {detail.result.actions_taken.map((item, idx) => (
                  <li key={`${item}-${idx}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {/* ── Toast ── */}
      {/* ── Order Detail Panel ── */}
      {showDetail && (
        <OrderDetailPanel
          order={selectedOrder || orders.find(o => o.order_id === selectedOrderId)}
          detail={detail}
          detailLoading={detailLoading}
          onClose={() => setShowDetail(false)}
          onApprove={async () => { await handleDecision('approve'); }}
          onReject={async ()  => { await handleDecision('reject');  }}
          onReprocess={async () => { await handleReprocess(); }}
        />
      )}

      {toastMessage && (
        <div className="o2c-toast">
          <IconCheck />
          {toastMessage}
        </div>
      )}
    </div>
  );
};

export default O2CAgent;
